<template>
  <section class="main-slider-activities">
    <div class="activities-slider">
      <DefSlider :settings="productSliderSettings" :pagination="true" :nav="screenWidth >= 992">
        <div v-for="item in result.products" :key="item?.offer?.id || item.id" class="swiper-slide">
          <SliderCard :result="item" />
        </div>
      </DefSlider>
    </div>
    <div class="activities-banners">
      <DefSlider :settings="bannerSliderSettings">
        <div
          v-for="item in result.items"
          :key="item.id"
          class="swiper-slide"
          :data-swiper-autoplay="+item.timeout * 1000 || 5000"
        >
          <div v-if="item.html">
            <DefInsertTildaSlider :result="item.html" />
          </div>
          <DefVideo v-else-if="item.video" :result="item.video" :loop="true" />
          <a v-else :href="item.link || item.detailPage">
            <!--animation or picture-->
            <DefImg
              v-if="item.animation || item.picture"
              :result="item.animation || item.picture"
            />
            <!--pictures-->
            <DefPicture v-else-if="item.pictures" :result="item.pictures" />
          </a>
        </div>
      </DefSlider>
    </div>
  </section>
</template>

<script setup lang="ts">
import DefSlider from '@components/Def/DefSlider/DefSlider.vue';
import { IMainSliderActivities } from '@components/sliders/MainSliderActivities/IMainSliderActivities';
import SliderCard from '@components/card/SliderCard/SliderCard.vue';
import type { SwiperOptions } from 'swiper/types';
import useScreenWidth from '@use/useScreenWidth';
import DefInsertTildaSlider from '@components/Def/DefInsertTilda/DefInsertTildaSlider.vue';
import DefVideo from '@components/Def/DefVideo/DefVideo.vue';
import DefImg from '@components/Def/DefImg/DefImg.vue';
import DefPicture from '@components/Def/DefPicture/DefPicture.vue';
import { Autoplay, EffectFade } from 'swiper/modules';

const props = defineProps<{
  result: IMainSliderActivities;
}>();

const screenWidth = useScreenWidth();

const productSliderSettings: SwiperOptions = {
  slidesPerView: 1.3,
  breakpoints: {
    992: {
      slidesPerView: 2,
      slidesPerGroup: 2,
    },
    768: {
      slidesPerView: 1,
    },
  },
};

const bannerSliderSettings: SwiperOptions = {
  slidesPerView: 1,
  effect: 'fade',
  modules: [EffectFade, Autoplay],
  autoplay: true,
};
</script>

<style lang="scss" scoped>
.main-slider-activities {
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  grid-row-gap: 16px;
  margin-bottom: 60px;
  @include point-md {
    grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
    grid-column-gap: 24px;
  }
  @include point-lg {
    margin-bottom: 80px;
    grid-template-columns: minmax(0, 0.6fr) minmax(0, 0.4fr);
    grid-column-gap: 32px;
  }
}
.activities-slider {
  order: 2;
  @include point-md {
    order: 1;
  }
}
.activities-banners {
  order: 1;
  padding-right: 16px;
  @include point-md {
    order: 2;
    padding-right: 0;
  }
  :deep(.def-picture),
  :deep(video) {
    width: 100%;
  }
}
</style>
